export default __webpack_public_path__ + "static/media/sketch_banner.3106d980.png";